import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=68a532ec&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"
import style0 from "./Packages.vue?vue&type=style&index=0&id=68a532ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a532ec",
  null
  
)

export default component.exports